const E = {
  JobDetails: 'Job Details',
  EditJob: 'Edit Job',
  SampleDetails: 'Sample Details',
  information: 'information',
  JobDetailsChanges: 'Job Details Changes',
  SampleTime: 'SampleTime',
  SampleIDChanges: 'Sample ID Changes',
  MessageOnCancel:
    'Any changes that have been made will not be saved. Do you want to proceed?',
  WarningUpdates: 'No updates have been requested',
  Expand: 'Expand',
  Collapse: 'Collapse',
  WarningFieldChanged: 'Red font indicates the field has been changed.',
  noEditableJobFields: 'The job details are not available for editing at this time. Please contact your Bureau Veritas representative for further assistance.',
  noSampleDetailsFields: 'The sample details are not available for editing at this time. Please contact your Bureau Veritas representative for further assistance.',
  EditjobModalMessage: 'This job has already been invoiced. Any changes to the project information will not be reflected on the existing invoice. If the invoice needs to be updated, please contact your Bureau Veritas representative.'
};

const F = {
  JobDetails: 'Informations du dossier',
  EditJob: 'Modifier le dossier',
  SampleDetails: 'Information sur l’échantillon',
  information: 'information',
  JobDetailsChanges: 'Modifier les informations du dossier',
  SampleTime: 'Temps de l’échantillon',
  SampleIDChanges: 'Modifier les ID de l’échantillon',
  MessageOnCancel:
    'Aucun changement ne sera sauvegardé. Souhaitez-vous procéder ?',
  WarningUpdates: 'Aucune mise à jour n’a été demandée',
  Expand: 'Agrandir',
  Collapse: 'Réduire',
  WarningFieldChanged:
    'Les caractères en rouge indiquent que le champ a été modifié.',
  noSampleDetailsFields: 'Les détails de l\'échantillon ne sont pas disponibles pour modification pour le moment. Veuillez contacter votre représentant Bureau Veritas pour obtenir de l\'aide.',
  noEditableJobFields: 'Les détails du dossier ne sont pas disponibles pour modification pour le moment. Veuillez contacter votre représentant Bureau Veritas pour obtenir de l\'aide.',
  EditjobModalMessage: 'Ce dossier a déjà été facturé. Toute modification apportée aux informations du projet ne sera pas reflétée sur la facture existante. Si la facture doit être mise à jour, veuillez contacter votre représentant Bureau Veritas.'
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/editJob.js